<template>
  <AlcoholSelector
    :currentAlcohols="otherAlcohols"
    icon="drinkstart"
    icon2="drinkend"
    >Utover det du allerede har fylt ut, er det andre tilfeller per uke som du
    ikke har fått med?
    <template v-slot:subheader>
      Er det noen tilfeller per uke utover det du har oppgitt, som du ikke har
      fått med, for eksempel en øl etter jobben eller et glass vin til maten?
      Oppgi hvor mye det kan være snakk om en vanlig uke.
    </template></AlcoholSelector
  >
</template>

<script>
import AlcoholSelector from "../common/AlcoholSelector";

export default {
  data() {
    return {};
  },
  components: {
    AlcoholSelector: AlcoholSelector,
  },
  computed: {
    otherAlcohols: {
      get() {
        return this.$store.state.otherAlcohols;
      },
      set(value) {
        this.$store.commit("setOtherAlcohols", {
          otherAlcohols: value,
        });
      },
    },
  },
};
</script>

<style lang="scss"></style>
